import { render } from "./Logos.vue?vue&type=template&id=0be2b4f6&scoped=true&ts=true"
import script from "./Logos.vue?vue&type=script&lang=ts"
export * from "./Logos.vue?vue&type=script&lang=ts"

import "./Logos.vue?vue&type=style&index=0&id=0be2b4f6&scoped=true&lang=css"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be2b4f6"]])

export default __exports__